<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <!-- <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户
        </router-link>
      </div> -->
      <div class="fl w-400">
        <el-input placeholder="请输入账号/真实姓名" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div><span class="m-l-30" style="color:#111;">企业：<span style="font-size:20px;font-weight:700;margin-top:7px;color:#111;">{{name}}</span></span>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="ID">
      </el-table-column>
      <el-table-column
      prop="user_head"
      label="头像">
        <template scope="scope">
          <el-popover
            placement="right-end"
            width="400"
            trigger="click">
            <img :src="scope.row.user_head?scope.row.user_head:logo2" width="100%">
            <img :src="scope.row.user_head?scope.row.user_head:logo2" width="50" height="50" slot="reference">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
      prop="username"
      label="账号">
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="真实姓名">
      </el-table-column>
      <el-table-column
      prop="create_time"
      label="加入时间">
      </el-table-column>
      <!-- <el-table-column
      label="性别">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.sex == 1" >男</span>
            <span v-else-if = "scope.row.sex == 2" style="color:red">女</span>
            <span v-else>未设置</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.examine_status ==1" style="color:#0c0">通过</span>
            <span v-else-if = "scope.row.examine_status ==0" style="color:#bb0">审核中</span>
            <span v-else-if = "scope.row.examine_status ==-1" style="color:#d00">删除</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
      label="操作"
      width="300">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="$router.push({ name: 'company_userEdit', params: { id: scope.row.id }})">编辑</el-button>
            </span>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pos-rel p-t-20">
      <!-- <btnGroup :selectedData="multipleSelection" :type="'company'" v-on:closeMain="init"></btnGroup> -->
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-company-user.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        name: '',
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该员工?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/company/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            id: this.$route.params.id,
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/company/company_user', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.name = data.name
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('company-save')
      },
      editShow() {
        return _g.getHasRule('company-update')
      },
      deleteShow() {
        return _g.getHasRule('company-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// company_user.vue?e7d1eac4